// @flow

// need window for legacy interfacing
/* eslint-disable no-restricted-globals */

import trackEventAjax, { trackEventCookie } from '@ta/common.tracking';

import type { ActionDef } from './types';

export const handleClick = (ev: SyntheticEvent<*>, action: ?ActionDef) => {
  if (!action || !action.type || !action.data) {
    return;
  }

  let track = null;
  if (action.trackingCategory && action.trackingLabel) {
    track = ({
      module: action.trackingCategory,
      action: 'click',
      context: action.trackingLabel,
    }: any);
    if (action.trackingValue || action.trackingValue === 0) {
      track.value = Number(action.trackingValue) || 0;
    }
  }
  let isAnchor = false;
  let anchorUrl = null;
  const { target } = ev;

  if (target && target instanceof HTMLAnchorElement) {
    isAnchor = true;
    anchorUrl = target.href;
  }

  switch (action.type) {
    case 'URL':
      try {
        if (track) {
          track.destinationUrl = action.data;
          trackEventCookie(track);
        }
      } finally {
        if (!isAnchor || anchorUrl !== action.data) {
          // override default anchor handling
          ev.preventDefault();
          window.location = action.data;
        }
      }
      break;

    case 'ASDFURL':
      ev.preventDefault();
      __non_webpack_require__(['utils/asdf-encoder'], encoder => {
        const url = encoder.asdf(action ? action.data : '');
        try {
          if (track) {
            track.destinationUrl = url;
            trackEventCookie(track);
          }
        } finally {
          window.location = url;
        }
      });
      break;

    case 'HELP_CENTER':
      window.require(
        ['trjs!brand/HelpCenterOverlay', 'trcss!src/build/required/help_center_overlay'],
        o => {
          o.open(target, '/uvpages/helpCenterOverlay.html');
        },
      );
      break;

    default:
      if (track) {
        trackEventAjax(track);
      }
      break;
  }
};

export default null;
